export function createTaskStatusRepository(config) {
    const { repository, client } = config;
    function getFindKey() {
        return ['platform', 'task', 'find'];
    }
    function getLookupKey(props) {
        return ['platform', 'task', 'status', 'lookup', props];
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getFindKey(),
                async queryFn() {
                    const response = await client.user.taskList({
                        xWorkspaceId: context.workspace.id,
                    });
                    return response.data.data;
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getLookupKey(props),
                async queryFn() {
                    throw new Error('not implemented');
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=taskStatusRepository.js.map